import React from "react"
import { useTranslation } from "react-i18next"
import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import AddStaffForm from "./AddStaffForm"
import styles from "./AddStaffModal.module.css"

const AddStaffModal = ({ open, onCancel, onSave, userId, staffId, editMode = false }) => {
  const [t] = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={800}
      closable
      maskClosable={false}
      destroyOnClose
      className={styles.staffModal}
      title={
        <div className={styles.header}>
          <Text className={styles.title} size="24">
            {editMode ? t("staff.edit_staff_modal.title") : t("staff.add_staff_modal.title")}
          </Text>
        </div>
      }
    >
      <AddStaffForm
        key={staffId || "new"}
        open={open}
        onCancel={onCancel}
        onSave={onSave}
        userId={userId}
        staffId={staffId}
        editMode={editMode}
        isFullScreen={false}
      />
    </Modal>
  )
}

export default AddStaffModal
